// @flow
import React, { Component } from 'react';
import { Grid, DropdownButton, MenuItem, Tabs, Tab, Row, Col, FormGroup, ControlLabel, FormControl, Table, Label, ListGroup, ListGroupItem, ProgressBar } from 'react-bootstrap';
import firebase from 'firebase';
import Loading from '../../components/Loading';
import { LANG } from '../../config';
import _ from 'lodash';

type IProps = {
  users: Array<Object>,
  lessons: Array<Object>,
  room: string,
  section: Object,
}

type IState = {
  lessonIndex: number,
  data: Object,
  loading: boolean,
}

class ListUser extends Component {  

  constructor(props: IProps) {
    super(props);

    this.state = {
      lessonIndex: 0,
      data: {},
      loading: true,
    };
  }

  state: IState;

  componentDidMount() {
    this.reload();
  }

  componentDidUpdate(prevProps: IProps, prevState: IState) {
    if (this.props.section.id !== prevProps.section.id) {
      this.reload();
    }
  }
  
  reload() {
    this.setState(
      {
        loading: true,
      },
      () => {
        const { room, section } = this.props;

        firebase.database()
        .ref(`room/${room}/${section.id}`)
        .on('value', (snapshot) => {
          const items = snapshot.val() || {};

          const object = {};
          Object.keys(items).map((key) => {
            const item = items[key];
            item.key = key;
            item.answers = [];
            item.valid = 0;
            item.total = 0;

            object[item.original] = item;
          });

          this.setState({
            data: object,
          });

          firebase.database()
          .ref(`room/${room}/${section.statistics}`)
          .on('value', (snapshot2) => {
            const statictics = snapshot2.val() || {};

            Object.keys(object).forEach((key) => {
              object[key].answers = [];
              object[key].valid = 0;
              object[key].total = 0;
            });
            
            Object.keys(statictics).map((key) => {
              const item = statictics[key];
              if (!item.deleted) {
                item.key = key;

                if (object[item.original]) {
                  object[item.original].answers.push(item);
                } else {
                  object[item.original] = {
                    original: item.original,
                    answers: [item],
                  };
                }
                
                object[item.original].total += 1;
                if (item.valid || item.accepted) {
                  object[item.original].valid += 1;
                }
              }
            });

            this.setState({
              data: object,
              loading: false,
            });
          });
        });
      },
    );
  }

  handleChangeTab(lessonIndex: string) {
    this.setState({
      lessonIndex,
    });
  }

  handleDropdownEvent(item, allAnswers, event) {
    const { room, section } = this.props;

    if (event === 'accept') {
      allAnswers.forEach((answer) => {
        const answers = [].concat(item[LANG.OTHER]);
        answers.push(answer.value);

        console.log(room, section.id, item.key, item.en, answers);

        const updates = {
          [`room/${room}/${section.id}/${item.key}/${LANG.OTHER}`]: _.uniq(answers),
          [`room/${room}/${section.statistics}/${answer.key}/accepted`]: true,
        };
        firebase.database().ref().update(updates);
      });
    }

    if (event === 'delete') {
      allAnswers.forEach((answer) => {
        const updates = {
          [`room/${room}/${section.statistics}/${answer.key}/deleted`]: true,
        };
        firebase.database().ref().update(updates);
      });
    }
  }
  
  props: IProps;

  render() {
    if (this.state.loading) return <Loading />;

    const { users, lessons } = this.props;
    const { data, lessonIndex } = this.state;

    const lessonKey = Object.keys(lessons)[lessonIndex];
    const lesson = lessons[lessonKey];

    const items = [];
    Object.keys(data).map((k) => {
      if (data[k].lesson === lessonKey) {
        items.push(data[k]);
      }
    });

    return (
      <div>
        <Tabs defaultActiveKey={lessonIndex} onSelect={this.handleChangeTab.bind(this)} animation={false} style={{ marginTop: '30px', marginBottom: '30px' }}>
          <Tab title="Lesson" disabled />
          {
            Object.keys(lessons).map((key, index) => (
              <Tab 
                key={key}
                eventKey={index}
                title={lessons[key].name} />
            ))
          }
        </Tabs>
        <Row>
          <Col xs={12}>
            <ListGroup>
              {
                items.map((item) => {
                  const percentage = parseInt((item.valid / item.total) * 100);
                  let style = "success";
                  if (percentage < 70) {
                    style = "warning";
                  }
                  if (percentage < 40) {
                    style = "danger";
                  }
                  if (item.answers) {
                    const answers = {};
                    const correct = {};
                    item[LANG.OTHER].forEach((i) => { correct[i.trim()] = 0; });

                    item.answers.forEach((answer, index) => {
                      if (!answer.valid) {
                        if (answers[answer.value]) {
                          answers[answer.value].push(answer);
                        } else {
                          answers[answer.value] = [answer];
                        }
                      }
                      if (answer.valid || answer.accepted) {
                        correct[answer.value.trim()] = (correct[answer.value.trim()] || 0) + 1;
                      }
                    });
                    return (
                      <ListGroupItem header={item.original}>
                        {
                          Object.keys(correct).sort((a, b) => { return correct[b] - correct[a]; }).map(i => <div>{i} ({correct[i]}x)</div>)
                        }
                        <h3>
                          <Label bsStyle="success">{item.valid}x</Label>&nbsp;
                          <Label bsStyle="danger">{item.total - item.valid}x</Label>&nbsp;
                          {
                            item.total > 0 && <Label bsStyle={style}>{percentage} %</Label>
                          }
                        </h3>
                        <div>
                          {
                            Object.keys(answers).sort((a, b) => { return answers[b].length - answers[a].length; }).map((answer, index) => {
                              const allAnswers = answers[answer];
                              return (
                                <DropdownButton onSelect={(event) => { this.handleDropdownEvent(item, allAnswers, event); }} bsSize="xsmall" bsStyle={allAnswers[0].accepted ? 'primary' : 'danger'} title={allAnswers.length > 1 ? `${answer} (${allAnswers.length}x)` : answer} key={index} id={`dropdown-basic-${index}`} style={{ margin: '3px 6px 3px 0px', display: 'inline-block', fontSize: '100%' }}>
                                  <MenuItem eventKey="accept">Accept</MenuItem>
                                  <MenuItem divider />
                                  <MenuItem eventKey="delete">Remove</MenuItem>
                                </DropdownButton>
                              );
                            })
                          }
                        </div>
                      </ListGroupItem>
                    );
                  }
                  return null;
                })
              }
            </ListGroup>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ListUser;


// WEBPACK FOOTER //
// ./src/pages/Statistics/ListRoom.js